module.exports = __webpack_public_path__ + "static/media/Month.731242d8.jpg";